import TEXT from "localisation";
import CloseIcon from '@mui/icons-material/Close';
import Chip from '@mui/material/Chip';

type Props = {
    values: [],
    onRemove: any,
    lableLookUp: string,
    options: object,
    field: string,
    setFilter: any,
    includeUI: boolean,
    correctValues: string[]
}

const FilterPill = ({ values, onRemove, lableLookUp, options, field, setFilter, includeUI = false, correctValues }: Props) => {
    const removePill = (v) => {
        if (includeUI && correctValues.length === 1) {
            onRemove(v)
            setFilter(`ui:${field === 'availability' ? 'availability' : 'category_code'}`, 'all', 'all')

        } else {
            onRemove(v)
        }

    }
    return (
        <>
            {
                correctValues.map((v) => {
                    return <Chip
                        key={v}
                        label={lableLookUp ? TEXT[`${lableLookUp}${v}`] : v}
                        sx={{ background: '#F3F3F3', color: '#4F4F4F', borderColor: '#F3F3F3' }}
                        onClick={(e) => {
                            removePill(v);
                        }}
                        onDelete={(e) => {
                            removePill(v);
                        }}
                        deleteIcon={<CloseIcon sx={{ 'height': '15px', 'width': '15px' }} />}
                        variant="outlined"
                    />
                })
            }
        </>
    )
};

export default FilterPill;